import * as firebase from "firebase"
require("firebase/firestore")

export const getDocById = (collection, id) => {
  return firebase.firestore().collection(collection).doc(id)
}

export const getVideos = (id_plan, terms) => {
  let reference = firebase.firestore().collection('video_index')
  let query = reference.where(id_plan, '==', true)

  if (terms && terms.length > 0) {
    for (let term of terms) {
      query = query.where('terms.'+term, '==', true)
    }
  }

  return (
    query
    .get()
    .then(querySnapshot => {
      let results = []
      querySnapshot.forEach(async doc => {
        results.push({
          id: doc.id
        })
      })
      return results
    })
  )
}
